<p>split-dropdown-date works!</p>
